module.exports = __webpack_public_path__ + "static/img/ja.67502af2.png";